export default {"src":"/_next/static/media/panasonic.b870f15c.svg","height":62,"width":176,"blurWidth":0,"blurHeight":0};